import { buildChildrenEffizienznetzwerkDokumentenablage, buildChildrenZusatztoolsDokumentenablage } from '../bereiche/informationen_hilfe/sitemap/buildChildren'
import { checkFunktionFuerBereich } from './functions/checkFunktionFuerBereich';
import * as config from '../wips.config.js';
import { disableKosten as disableKostenLinks } from '../helpers/showKosten';
import { getGewerk, getGewerkName, getWZobject } from './functions/getGewerk';
import { getStandorte } from '../helpers/getStandorte';
import { getStandorteGruppenTabRoutings } from '../bereiche/dateneingabe/functions/StandorteGruppen';
import { getVeranstaltungen } from '../helpers/getVeranstaltungen';
import { hasEffizienznetzwerk } from '../bereiche/helper';
import { hasErneuerbareEnergien } from './functions/hasErneuerbareEnergien';
import { hasKennzahlenSpez } from '../bereiche/datenauswertung/speziell/getKennziffernSpeziell';
import { i18n } from '../i18n/i18n';
import { i18n2 } from '../i18n/i18n_core';
import { IDs } from '../helpers/IDs';
import { isValid as isValidWaerme } from './functions/validData';
import { RoutingIDs } from '../helpers/RoutingIDs';
import { SectionStyle } from '../helpers/SectionStyle';
import { VeranstaltungsAuswahl } from '../helpers/VeranstaltungsAuswahl';
import { isEnableEnergiesteuerrueckerstattung } from '../bereiche/dateneingabe/assistent/assistent_helpers';
import { Features } from '../control/features';
import { hasFeature } from '../control/hasFeature';

export class Navigation {

    private apiService: any = {};
    public static cache: string[] = [];
    private contextService: any;
    private dataGlobal: any = {};
    private devFeaturesMap: any = config.devFeaturesMap || {};
    private modul: string;
    private noTranslation: boolean;
    private standorte: any[];
    private veranstaltungen: any[];

    constructor(data: any, apiService: any, contextService?: any, noTranslation?: boolean) {
        this.apiService = apiService || {};
        this.dataGlobal = data || {};
        this.noTranslation = !!noTranslation;
        this.standorte = getStandorte(this.dataGlobal) || [];
        this.veranstaltungen = getVeranstaltungen(this.dataGlobal) || [];

        if (contextService) {
            this.contextService = contextService;
        }
    }

    public getData(callback: (data: any) => void): void {
        if (typeof callback === 'function') {
            callback(this.buildArray());
        }
    }

    public getNodeFallback(node: any): any {
        const data: any[] = this.buildArray();
        node = node || {};
        const path: any = node.path || {};
        const id: number = path.selectedMenu;
        const cache: any = Navigation.cache[id] || {};
        const curNodes: any = data[id] || {};
        let fallback: any = {};
        const process = (item: any): void => {
            if ((item.children || []).length) {
                for (let i = 0; i < item.children.length; ++i) {
                    const child: any = item.children[i];

                    if (!child.disabled) {
                        process(child);
                        break;
                    } else {
                        continue;
                    }
                }
            } else {
                fallback = item;
            }
        };
        const checkPresets = (): void => {
            if (id === 1 && this.modul === 'cfm') {
                const hasVeranstaltungen: boolean = ((this.dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
                const indexStandorte: number = ((getStandorte(this.dataGlobal) || []).length > 1 || hasVeranstaltungen) ? 1 : 2;
                fallback = {
                    path: {
                        ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
                        [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: indexStandorte,
                        [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: 0,
                        terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
                    }
                };
            } else if (id === 1 && this.modul === 'steuer') {
                fallback = { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 } };
            } else {
                process(curNodes);
            }
        };

        if (Object.keys(cache).length) {
            this.getNodePath(cache, (path: any[], isDisabled: boolean) => {
                if (!isDisabled) {
                    fallback = cache;
                } else {
                    checkPresets();
                }
            });
        } else {
            checkPresets();
        }

        return fallback;
    }

    public getNodePath(node: any, callback?: (data: any, isDisabled: boolean) => void): any[] {
        const data: any[] = this.buildArray();
        node = node || {};
        const path: any = node.path || {};
        const id: number = path.selectedMenu;
        const curNodes: any = data[id] || {};
        const nodeKeys: any = {};
        const nodePath: any[] = [];
        let isDisabled: boolean = false;
        const process = (item: any): void => {
            if ((item.children || []).length) {
                loopChildren: for (let c = 0; c < item.children.length; ++c) {
                    const child: any = item.children[c];
                    const childPath: any = child.path || {};
                    const pathKeys: string[] = Object.keys(childPath);

                    for (let p = 0; p < pathKeys.length; ++p) {
                        const key: string = pathKeys[p];

                        if (childPath[key] === nodeKeys[key]) {
                            isDisabled = child.disabled ? true : isDisabled;
                            nodePath.push({ name: child.name, path: child.path });
                            delete nodeKeys[key];

                            if (!Object.keys(nodeKeys).length) {
                                break loopChildren;
                            } else if ((child.children || []).length) {
                                process(child);
                                break loopChildren;
                            }
                        }
                    }
                }
            }
        };
        // const process = (item: any): void => (item.children || []).forEach((child: any) => {
        //     Object.keys(child.path || {}).forEach((key: string) => {
        //         if (nodeKeys[key] === child.path[key]) {
        //             nodePath.push({ name: child.name, path: child.path });
        //             delete nodeKeys[key];

        //             if (!Object.keys(nodeKeys).length) {
        //                 return;
        //             } else if ((child.children || []).length) {
        //                 process(child);
        //             }
        //         }
        //     });
        // });

        Object.keys(path).forEach((key: string) => {
            if ((key || '').toString().startsWith('tab')) {
                nodeKeys[key] = path[key];
            }
        });
        nodePath.push({ name: curNodes.name, path: curNodes.path });
        process(curNodes);

        if (typeof callback === 'function') {
            callback(nodePath, isDisabled);
        }

        return nodePath;
    }

    private buildArray(): any[] {
        this.modul = this.dataGlobal.MODUL_SELECTED || null;
        const bereich_key: string = ((this.dataGlobal[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const gewerk = getGewerk(this.dataGlobal);
        const gewerkName: string = (getGewerkName(this.dataGlobal) || '').trim().toLowerCase();
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;
        const isAdmin = this.apiService.isAdmin();
        const isBerater = this.apiService.isBerater();
        const konfiguration: any = (this.dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const disabledAlternativesSystem: boolean = konfiguration.alternatives_system_orig !== 1;
        const disabledAnAbreise: boolean = bereich_key !== 'kultur';
        const disabledBwlDaten = true/*!hasGewerke*/;
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3 || konfiguration.co2_fussabdruck_orig !== 1;
        const disabledEffizienznetzwerk: boolean = !hasEffizienznetzwerk(this.dataGlobal);
        const disabledEnergiekostenProjektion: boolean = false;
        const disabledErneuerbareEnergien: boolean = konfiguration.daten_erneuerbare_energien_orig !== 1;
        const disabledFahrzeuge: boolean = !hasGewerke || konfiguration.daten_fahrzeuge_orig !== 1 || this.modul === 'cfm';
        const disabledKennzahlen = true/*!hasGewerke*/;
        const disabledKontakte: boolean = !checkFunktionFuerBereich('InformationenHilfe_Kontakte', bereich_key);
        const disabledLastgaenge: boolean = !IDs.FLAG_ENABLE_LASTGANG;
        const disabledInformationenHilfeFaq: boolean = !this.devFeaturesMap.N214_FAQ;
        const disabledInformationenHilfeMedien: boolean = !checkFunktionFuerBereich('InformationenHilfe_Medien', bereich_key);
        const disabledInformationenHilfePartner: boolean = !isAdmin && this.apiService.getUsername() !== 'yang.wang@wips-home.de';
        const disabledPvExperte: boolean = !isAdmin && !isBerater;
        const disabledMaschinen: boolean = !hasGewerke || konfiguration.daten_maschinen_orig !== 1 || this.modul === 'cfm';
        const disabledMotivation: boolean = this.modul !== 'cfm';
        const disabledStandorte: boolean = !hasGewerke || konfiguration.mehrere_standorte_orig !== 1;
        const disabledVeranstaltungen: boolean = konfiguration.veranstaltungen_orig !== 1;
        const disabledZustaendigkeiten: boolean = !hasGewerke || konfiguration.daten_zustaendigkeiten_orig !== 1;
        const disabledZusatztools: boolean = this.modul === 'cfm';
        const disabledZusatztoolsInfosBerater: boolean = !isAdmin && !isBerater;
        const disabledZusatztoolsEED: boolean = !this.devFeaturesMap.N271_MODUL_EED;
        // const disabledZusatztoolsSteuer: boolean = (+(getWZobject(this.dataGlobal) || {}).produzierendes_gewerbe || 0) === 0
        //     || gewerkName === 'kein handwerk' || gewerkName === 'handwerkskammer';
        const disabledZusatztoolsToolExcelImport: boolean = !checkFunktionFuerBereich('Zusatztools_Tab_Import_Excel', bereich_key);
        const disabledZusatztoolsZertifizierung: boolean = !checkFunktionFuerBereich('Zusatztools_Tab_Zertifizierung', bereich_key);
        const isGefuehrterModus: boolean = konfiguration.gefuehrter_modus_orig === 1;
        const Section: any = new SectionStyle();

        return [
            {
                name: this.i18n('Dateneingabe', 'tab'),
                color: Section.getPropertyValue('--color-button-text') || 'white',
                bgcolor: Section.getPropertyValue('--color-main-section-dateneingabe') || '#6f91be',
                path: RoutingIDs.ROUTE_DATENEINGABE,
                ...(isGefuehrterModus
                    ? {}
                    : {
                        children: [
                            {
                                name: this.i18n('Betriebliche Daten', 'tab'),
                                path: RoutingIDs.ROUTE_DATENEINGABE_BETRIEBLICHE_DATEN,
                                children: [
                                    {
                                        name: this.i18n('Motivation / Bilanzgrenzen', 'tab'),
                                        disabled: disabledMotivation,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_MOTIVATION,
                                    },
                                    {
                                        name: this.i18n('Konfiguration', 'tab'),
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KONFIGURATION,
                                    },
                                    {
                                        name: this.i18n('Unternehmensdaten', 'tab'),
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN,
                                    },
                                    {
                                        name: this.i18n('Standorte', 'tab'),
                                        disabled: disabledStandorte,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_STANDORTE_GEBAEUDE,
                                    },
                                    {
                                        name: this.i18n('Zuständigkeiten', 'tab'),
                                        disabled: disabledZustaendigkeiten,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_ZUSTAENDIGKEITEN,
                                    },
                                    {
                                        name: this.i18n('BWL-Daten', 'tab'),
                                        disabled: disabledBwlDaten,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_BWL_DATEN,
                                    },
                                    {
                                        name: this.i18n('Eigene Kennzahlen (Definition)', 'tab'),
                                        disabled: disabledKennzahlen,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KENNZAHLEN,
                                    },
                                    {
                                        name: this.i18n('Sonstige Daten', 'tab'),
                                        disabled: true,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_SONSTIGE_DATEN,
                                    },
                                    {
                                        name: this.i18n('Veranstaltungen', 'tab'),
                                        disabled: disabledVeranstaltungen,
                                        path: RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_VERANSTALTUNGEN,
                                    },
                                ],
                            },
                            {
                                name: this.i18n('Energiedaten', 'tab'),
                                path: RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX,
                                children: this.buildEnergiedatenArray(),
                            },
                            {
                                name: this.i18n('CO₂-Fußabdruck - Scope 3', 'tab'),
                                disabled: disabledCO2Komplex,
                                path: RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX,
                                children: this.buildCO2Array(),
                            },
                            {
                                name: this.i18n('Maschinen / Anlagen / Heizung', 'tab'),
                                disabled: disabledMaschinen,
                                path: RoutingIDs.ROUTE_DATENEINGABE_MASCHINEN_ANLAGEN,
                                children: this.buildMaschinenArray(),
                            },
                            {
                                name: this.i18n('Fahrzeuge', 'tab'),
                                disabled: disabledFahrzeuge,
                                path: RoutingIDs.ROUTE_DATENEINGABE_FAHRZEUGE,
                                children: this.buildFahrzeugeArray(),
                            },
                            {
                                name: this.i18n('Erneuerbare Energien / Eigenstrom', 'tab'),
                                disabled: disabledErneuerbareEnergien,
                                path: RoutingIDs.ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN,
                                children: this.buildErneuerbarEnergienArray(),
                            },
                            {
                                name: this.i18n('Eingabekontrolle', 'tab'),
                                path: RoutingIDs.ROUTE_DATENEINGABE_EINGABEKONTROLLE,
                            },
                            {
                                name: this.i18n('Energiedaten (Einzeln)', 'tab'),
                                disabled: !isAdmin && !isBerater,
                                path: RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN,
                                children: [
                                    {
                                        name: this.i18n('Strom', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_STROM,
                                    },
                                    {
                                        name: this.i18n('Wärme / Brennstoffe', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_WAERME,
                                    },
                                    {
                                        name: this.i18n('Kraftstoffe', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_KRAFTSTOFFE,
                                    },
                                    {
                                        name: this.i18n('Wasser / Abwasser', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_WASSER,
                                    },
                                    {
                                        name: this.i18n('Eigenstrom', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_EIGENSTROM,
                                    },
                                    {
                                        name: this.i18n('Eigenwärme', 'tab'),
                                        disabled: disabledErneuerbareEnergien,
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_EIGENWAERME,
                                    },
                                    {
                                        name: this.i18n('Gewerkespezifische und eigene Kennzahlen', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_KENNZIFFERN,
                                    },
                                    {
                                        name: this.i18n('BWL-Daten', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_BWL_DATEN,
                                    },
                                    {
                                        name: this.i18n('Klimagase', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_KLIMAGASE,
                                    },
                                    {
                                        name: this.i18n('Sicherheitszuschlag', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_SICHERHEITSZUSCHLAG,
                                    },
                                    {
                                        name: this.i18n('Scope 3.4 - Transport vorgelagert', 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_SCOPE3_TRANSPORT_VORGELAGERT,
                                    },
                                    {
                                        name: this.i18n(`Scope 3.6 - ${this.noTranslation ? 'Geschäftsreisen' : i18n2('Geschäftsreisen')}`, 'tab'),
                                        path: RoutingIDs.ROUTE_ENERGIEDATEN_SCOPE3_GESCHAEFTSREISEN,
                                    },
                                ],
                            },
                            {
                                name: this.i18n('Datencheck (Entwicklung)', 'tab'),
                                disabled: !isAdmin && !isBerater,
                                path: RoutingIDs.ROUTE_DATENEINGABE_DATENCHECK,
                            },
                            {
                                name: this.i18n('An- / Abreise', 'tab'),
                                disabled: disabledAnAbreise,
                                path: RoutingIDs.ROUTE_DATENEINGABE_AN_ABREISE,
                            },
                        ],
                    }
                ),
            },
            {
                name: this.i18n('Datenauswertung', 'tab'),
                color: Section.getPropertyValue('--color-button-text') || 'white',
                bgcolor: Section.getPropertyValue('--color-main-section-datenauswertung') || '#728a49',
                path: RoutingIDs.ROUTE_DATENAUSWERTUNG,
                children: this.buildDatenauswertungArray(),
            },
            /*
            {
                name: this.i18n('Effizienznetzwerk', 'tab'),
                color: Section.getPropertyValue('--color-button-text') || 'white',
                bgcolor: Section.getPropertyValue('--color-main-section-datenauswertung') || '#0093c6',
                disabled: disabledEffizienznetzwerk,
                path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK,
                children: [
                    {
                        name: this.i18n('Dokumentenablage', 'tab'),
                        path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
                        children: buildChildrenEffizienznetzwerkDokumentenablage(),
                    },
                    {
                        name: this.i18n('Monitoring Einzelmaßnahmen', 'tab'),
                        path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN,
                    },
                ],
            },
            */
            {
                name: this.i18n('Zusatztools', 'tab'),
                color: Section.getPropertyValue('--color-button-text') || 'white',
                bgcolor: Section.getPropertyValue('--color-main-section-zusatztools') || '#ea9956',
                disabled: disabledZusatztools,
                path: RoutingIDs.ROUTE_ZUSATZTOOLS,
                children: [
                    {
                        name: this.i18n('Energiekosten-Projektion', 'tab'),
                        disabled: disabledEnergiekostenProjektion,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_KOSTEN_PROJEKTION,
                    },
                    {
                        name: this.i18n('Dokumentenablage', 'tab'),
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE,
                        children: buildChildrenZusatztoolsDokumentenablage(),
                    },
                    {
                        name: this.i18n('Effizienznetzwerk', 'tab'),
                        disabled: disabledEffizienznetzwerk,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_EFFIZIENZNETZWERK,
                        children: [
                            {
                                name: this.i18n('Dokumentenablage', 'tab'),
                                path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
                                children: buildChildrenEffizienznetzwerkDokumentenablage(),
                            },
                            {
                                name: this.i18n('Monitoring Einzelmaßnahmen', 'tab'),
                                path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK_MONITORING_EINZELMASSNAHMEN,
                            },
                        ],
                    },
                    {
                        name: this.i18n('Ecomapping', 'tab'),
                        disabled: true,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_ECOMAPPING,
                    },
                    {
                        name: this.i18n('Entwicklungsfahrplan', 'tab'),
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_ENTWICKLUNGSPLAN,
                    },
                    {
                        name: this.i18n('Import: Excel E-Tool', 'tab'),
                        disabled: disabledZusatztoolsToolExcelImport,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_TOOL_EXCEL_IMPORT,
                    },
                    {
                        name: this.i18n('Lastgänge', 'tab'),
                        disabled: disabledLastgaenge,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_LASTGAENGE,
                    },
                    {
                        name: this.i18n('Mehrkosten CO₂ Bepreisung', 'tab'),
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_CO2_TOOL,
                    },
                    {
                        name: this.i18n('Monitoring Einzelmaßnahmen', 'tab'),
                        disabled: true,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_MONITORING_EINZELMASSNAHMEN,
                    },
                    {
                        name: this.i18n('PV Berechnungs-Tool', 'tab'),
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_PV,
                        children: [
                            {
                                name: this.i18n('Standard', 'tab'),
                                path: RoutingIDs.ROUTE_PV_STANDARD,
                            },
                            {
                                name: this.i18n('Experte', 'tab'),
                                disabled: disabledPvExperte,
                                path: RoutingIDs.ROUTE_PV_EXPERTE,
                            }
                        ]
                    },
                    {
                        name: this.i18n('Zähler', 'tab'),
                        disabled: true,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_ZAEHLER,
                    },
                    {
                        name: this.i18n('Zertifizierung', 'tab'),
                        disabled: disabledZusatztoolsZertifizierung,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_ZERTIFIZIERUNG,
                        children: [
                            {
                                name: this.i18n('Zertifizierungsoptionen', 'tab'),
                                path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_OPTIONEN,
                            },
                            {
                                name: this.i18n('Info Alternatives System', 'tab'),
                                disabled: disabledAlternativesSystem,
                                path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_INFO,
                            },
                            {
                                name: this.i18n('Tabellen', 'tab'),
                                disabled: disabledAlternativesSystem,
                                path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLEN,
                                children: [
                                    {
                                        name: this.i18n('Tabelle 1: Eingesetzte Energieträge', 'tab'),
                                        path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE1,
                                    },
                                    {
                                        name: this.i18n('Tabelle 2: Energieverbraucher', 'tab'),
                                        path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE2,
                                    },
                                    {
                                        name: this.i18n('Tabelle 3: Maßnahmen / Bewertung', 'tab'),
                                        path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TABELLE3,
                                    },
                                ],
                            },
                            {
                                name: this.i18n('Testierung', 'tab'),
                                disabled: true, // Im 1. Release auf Kundenwunsch raus
                                path: RoutingIDs.ROUTE_ZERTIFIZIERUNG_TESTIERUNG,
                            },
                        ],
                    },
                    {
                        name: this.i18n('Infos für Berater:innen', 'tab'),
                        disabled: disabledZusatztoolsInfosBerater,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_INFOS_BERATER,
                    },
                    {
                        name: this.i18n('Report / Export', 'tab'),
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_REPORT_EXPORT,
                    },
                    {
                        name: this.i18n('EED', 'tab'),
                        disabled: disabledZusatztoolsEED,
                        path: RoutingIDs.ROUTE_ZUSATZTOOLS_EED,
                    },
                ],
            },
            {
                name: this.i18n('Info / Hilfe', 'tab'),
                color: Section.getPropertyValue('--color-button-text') || 'white',
                bgcolor: Section.getPropertyValue('--color-main-section-informationen_hilfe') || '#686868',
                path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE,
                children: [
                    {
                        name: this.i18n('Allgemeine Erläuterungen', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_ERLAEUTERUNGEN,
                    },
                    {
                        name: this.i18n('Sitemap', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_SITEMAP,
                    },
                    {
                        name: this.i18n('FAQ', 'tab'),
                        disabled: disabledInformationenHilfeFaq,
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_FAQ,
                    },
                    {
                        name: this.i18n('Glossar', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_GLOSSAR,
                    },
                    {
                        name: this.i18n('Förderung', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_FOERDERUNG,
                    },
                    {
                        name: this.i18n('Medien / Anleitungen', 'tab'),
                        disabled: disabledInformationenHilfeMedien,
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_MEDIEN,
                    },
                    {
                        name: this.i18n('Emissionsfaktoren / Heizwerte', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_EMISSIONSFAKTOREN_HEIZWERTE,
                    },
                    {
                        name: this.i18n('Versionshistorie', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_VERSIONSHISTORIE,
                    },
                    {
                        name: this.i18n('Verifizierung / Auszeichnungen', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_VERIFIZIERUNG,
                    },
                    {
                        name: this.i18n('Kontakt / Unterstützung', 'tab'),
                        disabled: disabledKontakte,
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_KONTAKTE,
                    },
                    {
                        name: this.i18n('Partner:innen', 'tab'),
                        disabled: disabledInformationenHilfePartner,
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER,
                        children: [
                            {
                                name: this.i18n('Finanzierung', 'tab'),
                                path: RoutingIDs.ROUTE_PARTNER_FINANZIERUNG,
                            },
                            {
                                name: this.i18n('Entwicklung', 'tab'),
                                path: RoutingIDs.ROUTE_PARTNER_ENTWICKLUNG,
                            },
                            {
                                name: this.i18n('Kooperationspartner:innen', 'tab'),
                                path: RoutingIDs.ROUTE_PARTNER_WEITERFUEHREND,
                            },
                        ],
                    },
                    {
                        name: this.i18n('Nutzungsbedingungen / Datenschutz', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN,
                    },
                    {
                        name: this.i18n('Impressum', 'tab'),
                        path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_IMPRESSUM,
                    },
                ],
            },
        ];
    }

    private buildCO2Array(): any[] {
        // return getStandorteGruppenTabRoutings(
        //     { [IDs.ENT_STANDORT]: this.standorte },
        //     RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX,
        //     RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX
        // );
        const basisRouting: any = RoutingIDs.ROUTE_DATENEINGABE_CO2_KOMPLEX;
        const basisTab: any = RoutingIDs.TABS_DATENEINGABE_CO2_KOMPLEX;
        const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.dataGlobal, basisRouting, basisTab);
        const disabledVeranstaltungen: boolean = ((this.dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig !== 1;

        if (!disabledVeranstaltungen) {
            tabRoutings.push({
                name: this.i18n('Veranstaltungen', 'tab'),
                path: {
                    ...basisRouting,
                    [basisTab]: tabRoutings.length,
                    terminateOn: basisTab,
                },
            });
        }

        return tabRoutings;
    }

    private buildDatenauswertungArray(): any[] {
        const bereich_key: string = ((this.dataGlobal[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const gewerk = getGewerk(this.dataGlobal);
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;
        const konfiguration: any = (this.dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const disableKosten: boolean = disableKostenLinks(this.dataGlobal);
        const disabledEnergiekennzahlenKostenbezogen: boolean = disableKosten;
        const disabledVeranstaltungen: boolean = konfiguration.veranstaltungen_orig !== 1;
        const modul: string = this.dataGlobal.MODUL_SELECTED || null;
        const disabledEnergieCockpit: boolean = modul === 'cfm' || modul === 'steuer';
        const disabledThgBericht: boolean = modul !== 'cfm';
        const gewerkName: string = (getGewerkName(this.dataGlobal) || '').trim().toLowerCase();
        // Beim Steuer-Modul soll die Navigationsleiste immer angezeigt werden, unabhängig davon, ob es nur einen Hauptstandort gibt.
        const disabledGesamtunternehmen: boolean = modul !== 'steuer' && (this.standorte.length < 2 && disabledVeranstaltungen);

        const addCustomChildrenSettings = (childRouting: any, standort: any, index?: number) => {
            const kennzahlen: any = (this.dataGlobal[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid] || this.dataGlobal[IDs.KENNZIFFERN_BERECHNET] || {};
            const flags: any = kennzahlen.flags || {};
            let disabledStrom: boolean = !flags.hasStrom;
            let disabledWaerme: boolean = !flags.hasWaerme;
            let disabledKraftstoffe: boolean = !flags.hasKraftstoffe;
            let disabledWasser: boolean = !flags.hasWasser || modul === 'cfm';
            let disabledEnergiekennzahlen: boolean = !flags.hasKraftstoffe && !flags.hasWaerme && !flags.hasStrom;
            const disabledEnergiekennzahlenKostenbezogenSpez: boolean = disableKosten || !hasKennzahlenSpez(this.dataGlobal, 'kosten', standort.tid);
            const disabledEnergiekennzahlenVerbrauchsbezogenSpez: boolean = !hasKennzahlenSpez(this.dataGlobal, 'verbrauch', standort.tid);
            let disabledBetriebsdaten: boolean = !flags.hasBetriebsdaten;
            let disabledMaschinen: boolean = !flags.hasMaschinen || !hasGewerke || konfiguration.daten_maschinen_orig !== 1 || this.modul === 'cfm';
            let disabledFahrzeuge: boolean = !flags.hasFahrzeuge || !hasGewerke || konfiguration.daten_fahrzeuge_orig !== 1 || this.modul === 'cfm';
            let disabledErneuerbareEnergien: boolean = konfiguration.daten_erneuerbare_energien_orig !== 1
                || !hasErneuerbareEnergien(this.dataGlobal, standort.tid);
            let disabledCO2: boolean = !flags.hasCO2;
            const disabledAnteilStandorte: boolean = bereich_key !== 'kommunalverwaltung' || standort.tid;
            let disabledVsme: boolean = konfiguration.vsme_orig !== 1 || !standort.tid;
            let disabledKennzahlenberechnung: boolean = !this.apiService.isAdmin();

            // Für die Standorte (Hauptsitz + Filialen) wird keine eigene standortspezifische Steuerauswertung generiert.
            const isStandortspezifisch: boolean = standort.tid > 0;
            const isGesamt = !isStandortspezifisch;
            const keinEnergiesteuer: boolean = (+(getWZobject(this.dataGlobal) || {}).produzierendes_gewerbe || 0) === 0 || gewerkName === 'kein handwerk' || gewerkName === 'handwerkskammer';

            // WKETOOL-262: Folie 15 - In der Auswerung nur "Gesamt", keine Standorte (Achtung, im Screenshot sieht das anders aus)
            // Standorte werden im "Strom- / Energiesteuer" nicht berücksichtigt.
            // Gibt es nur einen Standort, wird "Strom- / Energiesteuer" unter diesem Standort angezeigt;
            // Gibt es mehr als einen Standort, wird dieses unter Gesamtunternehmen angezeigt.
            const disabledEnergiesteuer: boolean = (!isGesamt && this.standorte.length > 1) || keinEnergiesteuer;

            // Strom- und Energiesteuer-Modul
            if (modul === 'steuer') {
                const enableEnergiesteuerrueckerstattung: boolean = isEnableEnergiesteuerrueckerstattung(this.dataGlobal[IDs.ENT_KONFIGURATION] || []);
                disabledWaerme = !enableEnergiesteuerrueckerstattung || disabledWaerme;
                disabledKraftstoffe = true;
                disabledWasser = true;
                disabledEnergiekennzahlen = true;
                disabledBetriebsdaten = true;
                disabledMaschinen = true;
                disabledFahrzeuge = true;
                disabledErneuerbareEnergien = true;
                disabledCO2 = true;
                disabledVsme = true;
                disabledKennzahlenberechnung = true;
            }

            return {
                children: [
                    {
                        name: this.i18n('Strom', 'tab'),
                        disabled: disabledStrom,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM, ...childRouting },
                    },
                    {
                        name: this.i18n('Wärme / Brennstoffe', 'tab'),
                        disabled: disabledWaerme,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME, ...childRouting },
                        children: this.buildDatenauswertungWaermeArray(standort.tid, childRouting),
                    },
                    {
                        name: this.i18n('Kraftstoffe', 'tab'),
                        disabled: disabledKraftstoffe,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE, ...childRouting },
                    },
                    {
                        name: this.i18n('Wasser / Abwasser', 'tab'),
                        disabled: disabledWasser,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WASSER, ...childRouting },
                    },
                    {
                        name: this.i18n('Energiekennzahlen', 'tab'),
                        disabled: disabledEnergiekennzahlen,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN, ...childRouting },
                        children: [
                            {
                                name: this.i18n('Allg. Energiekennzahlen (kostenbezogen)', 'tab'),
                                disabled: disabledEnergiekennzahlenKostenbezogen,
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN, ...childRouting },
                            },
                            {
                                name: this.i18n('Allg. Energiekennzahlen (verbrauchsbezogen)', 'tab'),
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN, ...childRouting },
                            },
                            {
                                name: this.i18n('Spez. Kennzahlen (kostenbezogen)', 'tab'),
                                disabled: disabledEnergiekennzahlenKostenbezogenSpez,
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ, ...childRouting },
                            },
                            {
                                name: this.i18n('Spez. Kennzahlen (verbrauchsbezogen)', 'tab'),
                                disabled: disabledEnergiekennzahlenVerbrauchsbezogenSpez,
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ, ...childRouting },
                            },
                            {
                                name: this.i18n('Emissionen (CO₂)', 'tab'),
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_CO2_EMISSIONEN, ...childRouting },
                            },
                            {
                                name: this.i18n('Energiekennzahlen (Browser)', 'tab'),
                                disabled: true,
                                path: { ...RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_BROWSER, ...childRouting },
                            },
                        ],
                    },
                    {
                        name: this.i18n('Strom- / Energiesteuer', 'tab'),
                        disabled: disabledEnergiesteuer,
                        path: RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER,
                    },
                    {
                        name: this.i18n('Betriebsdaten', 'tab'),
                        disabled: disabledBetriebsdaten,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN, ...childRouting },
                    },
                    {
                        name: this.i18n('Maschinen / Anlagen / Heizung', 'tab'),
                        disabled: disabledMaschinen,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG, ...childRouting },
                    },
                    {
                        name: this.i18n('Fahrzeuge', 'tab'),
                        disabled: disabledFahrzeuge,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_FAHRZEUGE, ...childRouting },
                    },
                    {
                        name: this.i18n('Erneuerbare Energien', 'tab'),
                        disabled: disabledErneuerbareEnergien,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ERNEUERBARE_ENERGIEN, ...childRouting },
                    },
                    {
                        name: this.i18n('CO₂-Fußabdruck', 'tab'),
                        disabled: disabledCO2,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS, ...childRouting },
                        children: [
                            {
                                name: modul === 'cfm' ? this.i18n('Jahresauswertung', 'tab') : this.i18n('Alle Jahre', 'tab'),
                                path: { ...RoutingIDs.ROUTE_CO2_FUSS_GESAMT, ...childRouting },
                            },
                            {
                                name: modul === 'cfm' ? this.i18n('Alle Jahre', 'tab') : this.i18n('Jahresauswertung', 'tab'),
                                path: { ...RoutingIDs.ROUTE_CO2_FUSS_DETAILS, ...childRouting },
                            },
                            {
                                name: this.i18n('Anteil Standorte', 'tab'),
                                disabled: disabledAnteilStandorte,
                                path: { ...RoutingIDs.ROUTE_CO2_FUSS_ANTEIL_STANDORTE, ...childRouting },
                            },
                            {
                                name: this.i18n('THG-Bericht', 'tab'),
                                disabled: disabledThgBericht,
                                path: { ...RoutingIDs.ROUTE_CO2_FUSS_THG_BERICHT, ...childRouting },
                            },
                        ],
                    },
                    {
                        name: this.i18n('VSME', 'tab'),
                        disabled: disabledVsme,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_VSME, ...childRouting },
                        children: [
                            {
                                name: this.i18n('Auswertung', 'tab'),
                                path: { ...RoutingIDs.ROUTE_VSME_AUSWERTUNG, ...childRouting },
                            },
                            {
                                name: this.i18n('Report', 'tab'),
                                path: { ...RoutingIDs.ROUTE_VSME_REPORT, ...childRouting },
                            },
                        ],
                    },
                    {
                        name: this.i18n('Kennzahlenberechnung', 'tab'),
                        disabled: disabledKennzahlenberechnung,
                        path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KENNZAHLENBERECHNUNG, ...childRouting },
                    },
                ],
            }
        };

        const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
        const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
        const showStandorteTabs: boolean = modul !== 'steuer';
        const tabRoutings = [
            {
                name: this.i18n('Energie-Cockpit', 'tab'),
                disabled: disabledEnergieCockpit,
                path: {
                    ...basisRouting,
                    [basisTab]: 0,
                    terminateOn: basisTab,
                },
            },
            {
                name: this.i18n('Gesamtunternehmen', 'tab'),
                disabled: disabledGesamtunternehmen,
                path: {
                    ...basisRouting,
                    [basisTab]: 1,
                    terminateOn: basisTab,
                },
                ...addCustomChildrenSettings({}, { tid: 0 }),
            },
            ...(showStandorteTabs ? getStandorteGruppenTabRoutings({ [IDs.ENT_STANDORT]: this.standorte }, basisRouting, basisTab, 2, addCustomChildrenSettings) : []),
        ];

        if (!disabledVeranstaltungen && this.veranstaltungen.length) {
            if (!VeranstaltungsAuswahl.tid) {
                VeranstaltungsAuswahl.tid = (this.veranstaltungen.find((item: any) => item.tid === (this.veranstaltungen[0].tid)) || {}).tid;
            }
            tabRoutings.push({
                name: this.i18n('Veranstaltungen', 'tab'),
                path: {
                    ...basisRouting,
                    [basisTab]: tabRoutings.length,
                    terminateOn: basisTab,
                },
                ...addCustomChildrenSettings({ ...basisRouting, [basisTab]: tabRoutings.length }, { tid: VeranstaltungsAuswahl.tid }),
            });
        }

        return tabRoutings;
    }

    private buildDatenauswertungWaermeArray(standort_tid: number, childRouting: any): any[] {
        const energietraegerWaerme: any[] = this.dataGlobal[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
        const energiedaten: any[] = (this.dataGlobal[IDs.ENT_ENERGIEDATEN_WAERME] || [])
            .filter((item: any) => !standort_tid || (item.standort_tid_orig || null) === standort_tid)
            .filter((element: any, index: any, array: any) => {
                const energietraegerOK = element.energietraeger_tid_orig;
                const monatOK = !(element.monat || 0);
                const standortOK = (standort_tid ? (element.standort_tid_orig || null) === standort_tid : true);
                const validOK = true || isValidWaerme(element, IDs.ENT_ENERGIEDATEN_WAERME, this.dataGlobal);
                return standortOK && energietraegerOK && monatOK && validOK;
            })
            .map((item: any) => item.energietraeger_tid_orig);
        const gesamt: string[] = [];
        energietraegerWaerme.forEach((item: any) => energiedaten.indexOf(item.tid) !== -1 ? gesamt.push(item) : null);
        const energietraeger: any[] = [{ name: this.i18n('Brennstoffe - gesamt', 'tab'), gesamt }, ...energietraegerWaerme];

        return energietraeger.map((item: any, index: number) => {
            const tabWaerme: any = {
                ...childRouting,
                [RoutingIDs.TABS_DATENAUSWERTUNG_WAERME]: index,
            };
            return {
                name: item.name || null,
                disabled: item.gesamt ? gesamt.length < 2 : energiedaten.indexOf(item.tid) === -1,
                path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME, ...tabWaerme },
            };
        });
    }

    private buildEnergiedatenArray(): any[] {
        const basisRouting = RoutingIDs.ROUTE_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
        const basisTab = RoutingIDs.TABS_DATENEINGABE_ENERGIEDATEN_KOMPLEX;
        const disabledWasser: boolean = this.dataGlobal.MODUL_SELECTED === 'cfm';
        const eigenstromTitle: string = 'Eigenstrom';
        const stromTitle: string = 'Strom' ;
        const children: any[] = [
            {
                name: this.i18n(stromTitle, 'tab'),
                entities: [IDs.ENT_ENERGIEDATEN_STROM],
            },
            {
                name: this.i18n(eigenstromTitle, 'tab'),
                entities: [IDs.ENT_ENERGIEDATEN_EIGENSTROM],
            },
            {
                name: this.i18n('Wärme / Brennstoffe', 'tab'),
                entities: [IDs.ENT_ENERGIEDATEN_WAERME],
            },
            {
                name: this.i18n('Kraftstoffe', 'tab'),
                entities: [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE],
            },
            {
                name: this.i18n('Wasser / Abwasser', 'tab'),
                disabled: disabledWasser,
                entities: [IDs.ENT_ENERGIEDATEN_WASSER],
            },
            {
                name: this.i18n('Kennzahlen', 'tab'),
                entities: [IDs.ENT_KENNZIFFERN_GENERATED],
            },
            {
                name: this.i18n('BWL-Daten', 'tab'),
                entities: [IDs.ENT_BETRIEBSDATEN],
            },
            {
                name: this.i18n('Erfasser:in', 'tab'),
                entities: [IDs.ENT_SONSTIGE_DATEN],
            },
        ];

        const addCustomChildrenSettings = (childRouting: any) => {
            return {
                children: children.map((item: any) => {
                    return { ...item, path: { ...childRouting } };
                })
            }
        };
        const tabRoutings = getStandorteGruppenTabRoutings({ [IDs.ENT_STANDORT]: this.standorte }, basisRouting, basisTab, null, addCustomChildrenSettings);

        const disabledVeranstaltungen: boolean = ((this.dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig !== 1;

        if (!disabledVeranstaltungen) {
            tabRoutings.push({
                name: this.i18n('Veranstaltungen', 'tab'),
                path: {
                    ...basisRouting,
                    [basisTab]: tabRoutings.length,
                    terminateOn: basisTab,
                },
            });
        }
        return tabRoutings;
    }

    private buildErneuerbarEnergienArray(): any[] {
        return getStandorteGruppenTabRoutings(
            { [IDs.ENT_STANDORT]: this.standorte },
            RoutingIDs.ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN,
            RoutingIDs.TABS_DATENEINGABE_ERNEUERBARE_ENERGIEN
        );
    }

    private buildFahrzeugeArray(): any[] {
        return getStandorteGruppenTabRoutings(
            { [IDs.ENT_STANDORT]: this.standorte },
            RoutingIDs.ROUTE_DATENEINGABE_FAHRZEUGE,
            RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE
        );
    }

    private buildMaschinenArray(): any[] {
        return getStandorteGruppenTabRoutings(
            { [IDs.ENT_STANDORT]: this.standorte },
            RoutingIDs.ROUTE_DATENEINGABE_MASCHINEN_ANLAGEN,
            RoutingIDs.TABS_DATENEINGABE_MASCHINEN
        );
    }

    private i18n(value: string, key: string): string {
        return this.noTranslation ? value : i18n(value, key);
    }
}
